<template>
  <div class="image-wrapper">
    <img class="logo" :src="firstPageUrl" :alt="selectedReference.name" />
  </div>

  <div class="actions">
    <BbBtn class="preview-button" size="small" type="secondary" @click="previewDocument">
      <BbIcon size="small" name="preview" />
      <TextBody i18n-key="common.preview" />
    </BbBtn>
    <CollectionButton :document="selectedReference" />
    <BbBtn size="small" type="secondary" @click="handleAddToCollection">
      <BbIcon size="small" name="collection" />
    </BbBtn>
    <BbBtn size="small" type="secondary" @click="openTranslateDocument">
      <BbIcon size="small" name="translate" />
    </BbBtn>
  </div>
  <hr class="divider" />
  <DocumentMetadata :reference="selectedReference" />
</template>

<script>
import { computed, ref } from 'vue';
import useModals from '~/composables/useModals';
import useDocuments from '~/composables/useDocuments';
import DocumentMetadata from '~/components/conversation/documentPanel/DocumentMetadata';
import CollectionButton from '~/components/common/CollectionButton';
import TextBody from '~/components/common/TextBody';
import validateUrl from '~/utils/url';

export default {
  components: { DocumentMetadata, CollectionButton, TextBody },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const { showTranslationModal, showPreviewDocument, setCurrentDocumentsDialog, setAddToCollectionPopup } =
      useModals();
    const { selectedReference } = useDocuments();

    const isArchivedMode = ref(false);
    const firstPageUrl = computed(() =>
      validateUrl(selectedReference.value.pages?.[1]?.large) ? selectedReference.value.pages?.[1]?.large : '',
    );

    const onClose = () => {
      setCurrentDocumentsDialog(null);
    };

    const openTranslateDocument = () => {
      const { externalId, name } = selectedReference.value;
      showTranslationModal(externalId, name);
    };

    const previewDocument = () => {
      showPreviewDocument(1);
    };

    const handleAddToCollection = () => setAddToCollectionPopup({ open: true, document: selectedReference.value });

    return {
      firstPageUrl,
      handleAddToCollection,
      isArchivedMode,
      previewDocument,
      selectedReference,
      onClose,
      openTranslateDocument,
    };
  },
};
</script>

<style scoped lang="scss">
.divider {
  border: none;
  border-top: 1px solid #cecdcb;
  width: 100%;
  background-color: #ccc;
}

.image-wrapper {
  min-height: 20%;
  object-fit: contain;
  background-color: #d3d1c8;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  overflow: hidden;
  width: 100%;

  .logo {
    width: 100%;
    height: 100%;
    max-height: 100%;
    min-height: 100%;
    min-width: 100%;
    aspect-ratio: auto;
    object-fit: contain;
  }
}

.actions {
  display: flex;
  gap: $bb-spacing-1;
  padding: $bb-spacing-4;
  width: 100%;
  align-items: center;

  .favorite-button {
    :deep(.v-btn__content) {
      color: red;
    }
  }
}

.preview-button {
  flex: auto;

  :deep(.v-btn__content) {
    gap: $bb-spacing-1;
  }
}
</style>
